import { BUTTONS, PluginSettingsIcon } from 'wix-rich-content-plugin-commons';
import { c as convertLinkPreviewToLink } from '../utils-c4245f57.js';
import ConvertToLinkIcon from '../icons/ConvertToLinkIcon.js';
import 'lodash';
import '../defaults.js';
import 'wix-rich-content-editor-common';
import 'react';

const createInlineButtons = ({
  setEditorState,
  getEditorState
}) => {
  return [
    {
      keyName: "link",
      type: BUTTONS.LINK_PREVIEW,
      mobile: true,
      icons: PluginSettingsIcon,
      tooltipTextKey: "LinkPreview_Settings_Tooltip"
    },
    {
      keyName: "replaceToLink",
      type: BUTTONS.CUSTOM,
      icon: ConvertToLinkIcon,
      onClick: () => {
        const editorState = getEditorState();
        setEditorState(convertLinkPreviewToLink(editorState));
      },
      mobile: true,
      desktop: true,
      tooltipTextKey: "LinkPreview_RemovePreview_Tooltip"
    },
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
